import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; import Button from 'components/Button';
import './styles.scss';

const loadingIcon = (<i className='fa fa-spinner fa-spin fa-lg fa-fw fl-loading' />);

const BackNextFooter = ({ onBack, onNext, isRequesting }) => {
    return (
        <div className='back-next-footer-container'>
            <Button
                className='back-next-footer-buttons back'
                text={ i18n.t('engagement.back') }
                onClick={ onBack }
                width='170' />
            <Button
                disabled={ onNext === null }
                icon={ isRequesting ? loadingIcon : null }
                className='back-next-footer-buttons'
                text={ i18n.t('engagement.next') }
                onClick={ onNext }
                width='170' />
        </div>
    );
};

BackNextFooter.propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    isRequesting: PropTypes.bool
};

BackNextFooter.defaultProps = {
    onBack: null,
    onNext: null,
    isRequesting: false
};


export default BackNextFooter;
